import axiosClient from "./AxiosConfig";

const UserService = {

  async getUserInfo() {
    return await axiosClient.get(`/user/me`);
  }
};

export default UserService;
